import { fromJS } from 'immutable';
import { createSelector } from 'reselect';

import * as utils from '@src/utils/duckHelpers';

const platformsTypes = {
    ...utils.requestTypes('PLATFORMS'),
};

const actions = {
    platformsSet: (obj) => utils.action(platformsTypes.PLATFORMS_SET, obj),
};

const initialState = fromJS({
    loaded: 'loading',
    platforms: [],
});

const platformsReducer = (state = initialState, action) => {
    switch (action.type) {
    case platformsTypes.PLATFORMS_GET:
        return state.merge({
            loaded: 'loading',
        });
    case platformsTypes.PLATFORMS_SET:
        if (action.payload.platforms) {
            if (action.payload.platforms.length > 0) {
                return fromJS({
                    platforms: action.payload.platforms,
                    loaded: 'complete',
                });
            }
        }

        return fromJS({
            platforms: [],
            loaded: 'empty',
        });
    case platformsTypes.PLATFORMS_RESET:
        return initialState;
    default:
        return state;
    }
};

const getPlatforms = (state) => state.get('app').get('platforms');

const selectors = {
    getPlatforms: getPlatforms,
};

export {
    platformsTypes,
    actions,
    selectors,
    platformsReducer as default,
};
